import script from "./MessageBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageBlock.vue?vue&type=script&setup=true&lang=ts"

import "./MessageBlock.vue?vue&type=style&index=0&id=2dbca754&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dbca754"]])

export default __exports__